<template>
  <div>
    <div class="ai-dialog-content">
      <slot name="content"></slot>
    </div>

    <v-divider class="ai-dialog-divider" />

    <div class="ai-dialog-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiActionWrapper',
}
</script>
